var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-card',[_c('vc-calendar',{attrs:{"is-expanded":"","locale":"es","mode":"range","attributes":_vm.attributes,"value":null,"color":"red","is-dark":"","popover.placement":"auto","is-inline":""},on:{"update:from-page":_vm.pageChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }